export default {
    symptomatic_1: 'Symptomatic',
    symptomatic_2: 'Asymptomatic',
    symptomatic_3: 'Any',
};
